import { CircleDollarSign } from "lucide-react";
import PlaceholderPage from "./PlaceholderPage";

export default function PaymentAuthorizations() {
  return (
    <PlaceholderPage 
      title="Payment Authorizations" 
      description="Securely process client payment authorizations for trip deposits and other travel expenses."
      icon={<CircleDollarSign size={48} />} 
    />
  );
}